var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDetailIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Detail-icon",
    transform: "translate(-167 -140)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_899",
    "data-name": "Ellipse 899",
    transform: "translate(167 140)",
    fill: "#fff",
    stroke: "#a8aab7",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 11.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5916",
    "data-name": "Rectangle 5916",
    width: 3,
    height: 9,
    rx: 1.5,
    transform: "translate(178 150)",
    fill: "#a8aab7"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_5917",
    "data-name": "Rectangle 5917",
    width: 3,
    height: 3,
    rx: 1.5,
    transform: "translate(178 146)",
    fill: "#a8aab7"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDetailIcon);
export default __webpack_public_path__ + "static/media/Detail-icon.8d8b560697e5a75d4cc3b15a685e1f78.svg";
export { ForwardRef as ReactComponent };